import { Injectable } from '@angular/core';
import { StoreData } from '@shared/module/common/model/store-data';
import { User } from '@lemsar/auth/domains/models/user';
import { Storage } from '@ubud/storage';
import { Observable } from 'rxjs/Observable';
import { NacoService } from '@naker/naco';
import { AuthService } from '@lemsar/auth/domains/services/auth.service';
import { switchMap, tap } from 'rxjs/internal/operators';
import { of } from 'rxjs/index';

@Injectable()
export class AuthStore {
    private readonly _user: StoreData<User>;

    public constructor(private storage: Storage, private naco: NacoService, private auth: AuthService) {
        this._user = new StoreData<User>(new User());
    }

    public get user(): User {
        return this._user.value;
    }

    public get user$(): Observable<User> {
        return this._user.stream$;
    }

    public init(): Promise<void> {
        return new Promise<void>(resolve => {
            const response = this.naco.getUser().pipe(
                switchMap((user: any) => {
                    if (user) {
                        return this.auth.isRegistered().pipe(
                            switchMap((registered: boolean) => {
                                if (registered) {
                                    return this.auth.getUser().pipe(
                                        tap((authUser: any) => {
                                            if (authUser) {
                                                this._user.value = authUser;
                                            }
                                        }),
                                    );
                                }

                                return of(null);
                            }),
                        );
                    }

                    return of(null);
                }),
            );

            response.subscribe(() => resolve());
        });
    }

    public logout(): void {
        const redirectUri = this.naco.getCurrentOrigin();

        this.naco.logout(redirectUri).then((endpoint: string) => {
            this._user.value = new User();

            window.location.href = endpoint;
        });
    }

    public clear(): Promise<void> {
        return new Promise<void>(resolve => {
            this.naco.logout().then(() => {
                this._user.value = new User();
                resolve();
            });
        });
    }

    public refreshUser(): Promise<void> {
        const stmt = this.auth.isRegistered().pipe(
            switchMap((registered: boolean) => {
                if (registered) {
                    return this.auth.getUser();
                }

                return of(null);
            }),
        );

        return stmt.toPromise().then((user: any) => {
            if (user) {
                this._user.value = user;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/storage/stores/auth.store.ts